'use server'

import { apiRequest, ApiResponse } from '../request'

export interface SalesPipelineConfig {
    id: number
    companyId: number
    allowMultiplePipelines: boolean
    allowLeadInMultiplePipelines: boolean
    autoAssignLeadWallet: boolean
    autoAssignDealWallet: boolean
    sentimentAnalysisEnabled: boolean
    scoreDecayEnabled: boolean
    scoreDecayDays: number
    /** Perfis que veem todos os funis da organização (docs/sales-pipeline-distribution.md). */
    viewAllPipelinesRoleIds: number[]
    createdAt: string
    updatedAt: string
}

export interface UpdateSalesConfigData {
    allowMultiplePipelines?: boolean
    allowLeadInMultiplePipelines?: boolean
    autoAssignLeadWallet?: boolean
    autoAssignDealWallet?: boolean
    sentimentAnalysisEnabled?: boolean
    scoreDecayEnabled?: boolean
    scoreDecayDays?: number
    /** Exige também permissão de edição de funis. */
    viewAllPipelinesRoleIds?: number[]
}

export async function getSalesConfig(): Promise<ApiResponse<SalesPipelineConfig>> {
    return apiRequest<SalesPipelineConfig>('sales/config', {})
}

export async function updateSalesConfig(
    data: UpdateSalesConfigData
): Promise<ApiResponse<SalesPipelineConfig>> {
    return apiRequest<SalesPipelineConfig>('sales/config', { data }, 'patch')
}
